// src/utils/cartUtils.js
export const saveProductToSession = (product) => {
  sessionStorage.setItem('pendingCartItem', JSON.stringify(product));
};

export const getPendingCartItem = () => {
  const item = sessionStorage.getItem('pendingCartItem');
  sessionStorage.removeItem('pendingCartItem'); // Clear after retrieving
  return item ? JSON.parse(item) : null;
};

// Generate or get existing session ID for guest users
export const getGuestSessionId = () => {
  let sessionId = sessionStorage.getItem('guestSessionId');
  if (!sessionId) {
    sessionId = `guest_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('guestSessionId', sessionId);
  }
  return sessionId;
};
